import PopupActions from '../../actions/PopupActions';

import NotificationActions from '../../actions/NotificationActions';
import RoutingActions from '../../actions/RoutingActions';
import GuestListActions from '../../actions/GuestListActions';

import UserStore from '../../stores/UserStore';
import ConfigStore from '../../stores/ConfigStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as EndPoints } from '../../constants/PosConstants';
import BirthdateCheckModal from '../pos/checkout/BrithdateCheckModal';

class GLSidebar extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			showBirthdatePopup: false
		}

		this.requestRecreationalUser = this.requestRecreationalUser.bind(this);
		this.validateRecTransaction = this.validateRecTransaction.bind(this);
		this.createRecTransaction = this.createRecTransaction.bind(this);
	}

	requestRecreationalUser() {
        var self = this;

        if (!UserStore.getState().selectedRegister) {
        	NotificationActions.addNotification({body : 'Select register to continue', type : 'alert' });
        	return;
        }

        var formData        = UserStore.getApiData();
        formData.TerminalId = UserStore.getState().selectedRegister.id;
        formData.UserId     = UserStore.getState().user.userId;
        formData.RoomId     = 0;

        AjaxPromises.POST(EndPoints.RECREATIONAL, 
            formData
        ).then(res => {
            if (!res.Result || (res.Data && res.Data[0] && res.Data[0].ScanId === 0)) {
                NotificationActions.error(res.Data && res.Data[0] ? res.Data[0].ScanResult : res.Message);
            } else {
                RoutingActions.updateRoute('pos/'+res.Data[0].AcctId);
                GuestListActions.loadGuestList();
            }
        });
	}

	validateRecTransaction() {
		if(this.props.selectedLocation.ConfirmBirthdayOnCheckin) {
			this.setState({ showBirthdatePopup: true })
		} else {
			this.createRecTransaction();
		}
	}

	createRecTransaction() {
		if(this.props.selectedLocation.CollectAnonymousDemo) {
			this.props.goToPage('new-anon-profile') 
		} else {
			this.requestRecreationalUser();
		}
	}

    render() {
    	var page = this.props.page,
    		selectedLocation = this.props.selectedLocation,
			selectedRegister = this.props.selectedRegister,
			locations = this.props.locations,
            registers = this.props.registers;

        return (
            <div className='profile-sidebar gl-sidebar'>

				{ this.state.showBirthdatePopup &&
					<BirthdateCheckModal 
						UserId={UserStore.getState().user.UserId}
						onClose={(success) => {
							if(success) {
								this.createRecTransaction();
							}
							this.setState({ showBirthdatePopup: false })
						}}
					/>
            	}

            	<div className='profile-sidebar__nav'>
            		{ selectedLocation &&
		                <div
		                	className={'profile-sidebar__item '+(page === 'list' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('list'); }}>

		                	{ page === 'list' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	{ selectedLocation.CompanyFlag === 'Dispensary' ? 'Guest List' : 'Customer List' }
		                </div>
		            }

		            { selectedLocation &&
		                <div className={'profile-sidebar__item '+(page === 'search' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('search'); }}>
		                	{ page === 'search' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	Search Results
		                </div>
		            }

		            { selectedLocation &&
		                <div className={'profile-sidebar__item '+(page === 'new-profile' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('new-profile'); }}>
		                	{ page === 'new-profile' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	{ selectedLocation.CompanyFlag === 'Dispensary' ? 'New Profile' : 'New Customer Profile' }
		                </div>
		            }
					{
						locations.length > 1 &&
						<div className={'profile-sidebar__item '+(page === 'location' ? 'profile-sidebar__item--selected' : '')}
							onClick={() => { this.props.goToPage('location'); }}>
							{ page === 'location' &&
								<div className='profile-sidebar__item--triangle' />
							}
							Select Location
						</div>
					}

		            { selectedLocation && registers.length > 1 &&
		                <div className={'profile-sidebar__item '+(page === 'register' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('register'); }}>
		                	{ page === 'register' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	Select Register
		                </div>
		            }

		            { selectedLocation && selectedLocation.UseBioTrackPOS &&
		                <div className={'profile-sidebar__item '+(page === 'biotrack' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('biotrack'); }}>
		                	{ page === 'biotrack' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	Biotrack
		                </div>
		            }

		            { selectedLocation && selectedLocation.RecreationalFlag &&
		                <div className='profile-sidebar__item'
		                	onClick={this.validateRecTransaction}>
		                	Recreational Transaction
		                </div>
		            }

                    { selectedLocation &&
		                <div className={'profile-sidebar__item '+(page === 'quick-scan' ? 'profile-sidebar__item--selected' : '')}
		                    onClick={() => { this.props.goToPage('quick-scan'); }}>
		                    { page === 'quick-scan' &&
		                	    <div className='profile-sidebar__item--triangle' />
		                    }
		                    Security Check-In
		                </div>
                    }

		            { selectedRegister && selectedLocation && selectedLocation.ShowPOSTransactionsTab &&
		                <div className={'profile-sidebar__item '+(page === 'close-out' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('close-out'); }}>
		                	{ page === 'close-out' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	Transactions
		                </div>
					}

					{ selectedRegister && selectedLocation && selectedLocation.PriceCheck &&
                            <div
							className={'profile-sidebar__item'}
							onClick={() => { PopupActions.open('price-check', false); }}>

							Price Check
						</div>
					}
					
					{
						(selectedLocation.CanUseMassDPHIntegration) && 
		                <div className={'profile-sidebar__item '+(page === 'dph-settings' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('dph-settings'); }}>
		                	{ page === 'dph-settings' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	MassCIP Settings
		                </div>
					}
					 {/* { selectedLocation &&
		                <div className={'profile-sidebar__item profile-sidebar__item--border-top '+(page === 'status' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('status'); }}>
		                	{ page === 'status' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	System Status
		                </div>
		            } */}
	            </div>

	            <div className='gl-sidebar__signout'>
		            { selectedLocation &&
		                <div className={'profile-sidebar__item profile-sidebar__item--border-top '+(page === 'settings' ? 'profile-sidebar__item--selected' : '')}
		                	onClick={() => { this.props.goToPage('settings'); }}>
		                	{ page === 'settings' &&
		                	   	<div className='profile-sidebar__item--triangle' />
		                	}
		                	Settings
		                </div>
		            }
	            </div>
            </div>
        );
    }
}

export default GLSidebar;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLSidebar.react.jsx